import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { DirectionProvider } from "./contexts/Direction";
import { LoginModalProvider } from "./contexts/LoginModal";
import { NotificationProvider } from "./contexts/Notification";
import { ThemeProvider } from "./contexts/Theme";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import "font-awesome/css/font-awesome.min.css";


const rootElement = document.getElementById("root") as HTMLElement;

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <DirectionProvider>
        <LoginModalProvider>
          <NotificationProvider>
            {/* Include Header component here */}
            <App />
          </NotificationProvider>
        </LoginModalProvider>
      </DirectionProvider>
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();
